import React from "react";
// WARNING: do not change anything

const GreenBrace = () => {
  return (
    <div id="curly-brace">
      <div id="left" className="brace"></div>
      <div id="right" className="brace"></div>
      <style jsx>{`
        .brace {
          border-bottom: 1px solid #5b5675;
          margin: 0 10%;
          width: 30%;
          height: 18px;
          float: left;
        }

        .brace:before,
        .brace:after {
          content: "";
          width: 10%;
          height: 50px;
          position: absolute;
          display: block;
        }

        #left:before {
          border-bottom: 1px solid #5b5675;
          border-bottom-left-radius: 6px;
          margin-left: -10%;
          margin-top: -32px;
        }

        #left:after {
          border-top: 1px solid #5b5675;
          border-top-right-radius: 9px;
          margin-left: 30%;
          margin-top: 18px;
        }

        #right:before {
          border-top: 1px solid #5b5675;
          border-top-left-radius: 9px;
          margin-left: -10%;
          margin-top: 18px;
        }

        #right:after {
          border-bottom: 1px solid #5b5675;
          border-bottom-right-radius: 6px;
          margin-left: 30%;
          margin-top: -32px;
        }
      `}</style>
    </div>
  );
};

export default GreenBrace;
